import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import TaskWorkflowStore from "./TaskWorkflow.Store";

/**
 * Task Workflow Route
 *
 * Digital task queue system per spec 03-task-approval-workflow.md
 * Replaces paper-based approval routing with digital queues
 */
const taskWorkflowRoute: RouteType = {
  name: "Task Workflow",
  path: "/accounting/task-workflow",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Task Workflow",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./TaskWorkflow.Header"),
    },
    body: {
      component: () => import("./TaskWorkflow.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).taskWorkflowStore as TaskWorkflowStore;
    if (store) {
      await store.loadTasks();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).taskWorkflowStore as TaskWorkflowStore;
    if (store) {
      await store.loadTasks();
    }
  },
  onExit: ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).taskWorkflowStore as TaskWorkflowStore;
    if (store) {
      store.reset();
    }
  },
  dialogs: [
    {
      name: "taskDetail",
      title: "Task Details",
      component: () => import("./dialogs/TaskDetailDialog.Body"),
      cancelButton: true,
      height: 600,
    },
    {
      name: "returnNote",
      title: "Return Task",
      component: () => import("./dialogs/ReturnNoteDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).taskWorkflowStore as TaskWorkflowStore;
        if (store?.selectedTask && store.returnNote.trim()) {
          await store.returnTask(store.selectedTask.id);
        }
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).taskWorkflowStore as TaskWorkflowStore;
        return !store?.returnNote?.trim();
      },
      cancelButton: true,
      height: 300,
    },
    {
      name: "delegate",
      title: "Delegate Task",
      component: () => import("./dialogs/DelegateDialog.Body"),
      cancelButton: true,
      height: 350,
    },
    {
      name: "taskHistory",
      title: "Task History",
      component: () => import("./dialogs/TaskHistoryDialog.Body"),
      cancelButton: true,
      height: 500,
    },
  ],
};

export default taskWorkflowRoute;
